import classNames from "classnames/bind";
import RankingItem from "./RankingItem";
import {head} from "./list";
import CloseBtn from "images/redbrickEvent/JUMP/playevent_jump_icon_x_01.png";
import styles from "./index.module.scss";

const cn = classNames.bind(styles);
export default function View({myRank, ranks, myId, isCloseUsable, singlePopup, name, closeHandler}) {
  return (
    <div className={cn("ranking_board")}>
      {isCloseUsable && (
        <button className={cn("close")} type="button" onClick={closeHandler}>
          <img alt="close" src={CloseBtn} />
        </button>
      )}

      <h3 className={cn("title")}>Leaderboard</h3>

      <div className={cn("board_head")}>
        {head.map(item => (
          <span className={cn("head")} key={item.id}>
            {item.title}
          </span>
        ))}
      </div>

      <div className={cn("board_list")}>
        <RankingItem
          self
          ranking={myRank.rank ? myRank.rank : "-"}
          ci={myId}
          record={myRank?.data?.best ? myRank.data.best : "-"}
          name={name}
        />

        {ranks.length > 0 &&
          ranks.map((rank, index) => (
            <RankingItem self={myId === rank.ci} key={index} ci={rank.ci} ranking={index + 1} record={rank.best} name={rank.ci_user.name} />
          ))}
      </div>
    </div>
  );
}
